(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kjpg-store-locator"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
  if (!root || root.getAttribute('data-kpl-ready')) return;
  root.setAttribute('data-kpl-ready', '1');
  root.classList.add('is-ready');
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var input = $('[data-q]'), clear = $('[data-clear]'), count = $('[data-count]'), msg = $('[data-msg]');
  var empty = $('[data-empty]'), term = $('[data-term]'), locate = $('[data-locate]');
  var cards = $$('[data-store]'), heads = $$('[data-ghead]'), chips = $$('[data-brand-btn]');
  var picks = $$('[data-pick]'), sorts = $$('[data-sort]');
  var mapBox = $('.kpl__map[data-map]'), mapName = $('[data-mapname]'), mapDir = $('[data-mapdir]');
  var desk = window.matchMedia('(min-width: 990px)');
  var brand = 'all', mode = 'rec', here = null, selected = null;

  function norm(v) { return (v || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim(); }
  function ist() { var d = new Date(); return new Date(d.getTime() + d.getTimezoneOffset() * 60000 + 330 * 60000); }
  function fmt(m) { var h = Math.floor(m / 60), mi = m % 60, ap = h >= 12 ? 'PM' : 'AM'; h = h % 12 || 12; return h + ':' + (mi < 10 ? '0' : '') + mi + ' ' + ap; }
  function km(a, b, c, d) {
    var r = Math.PI / 180, x = Math.sin((c - a) * r / 2), y = Math.sin((d - b) * r / 2);
    return 12742 * Math.asin(Math.sqrt(x * x + Math.cos(a * r) * Math.cos(c * r) * y * y));
  }

  $$('.kpl__list > li').forEach(function (el, i) { el._i = i; el.style.order = i; });
  cards.forEach(function (c) {
    c._k = norm(c.getAttribute('data-search'));
    c._h = JSON.parse(c.getAttribute('data-hours'));
    c._lat = parseFloat(c.getAttribute('data-lat')); c._lng = parseFloat(c.getAttribute('data-lng'));
  });

  function status() {
    var n = ist(), day = n.getDay(), mins = n.getHours() * 60 + n.getMinutes();
    cards.forEach(function (c) {
      var pill = c.querySelector('[data-status]'), h = c._h, t = h[day], cls, txt;
      if (t && mins >= t[0] && mins < t[1]) {
        if (t[1] - mins <= 60) { cls = 'is-soon'; txt = 'Closes soon, ' + fmt(t[1]); }
        else { cls = 'is-open'; txt = 'Open now, until ' + fmt(t[1]); }
      } else if (t && mins < t[0]) { cls = 'is-closed'; txt = 'Opens ' + fmt(t[0]) + ' today'; }
      else {
        for (var k = 1; k <= 7; k++) { var dd = (day + k) % 7; if (h[dd]) { cls = 'is-closed'; txt = 'Closed, opens ' + fmt(h[dd][0]) + (k === 1 ? ' tomorrow' : ' ' + DAYS[dd]); break; } }
      }
      pill.className = 'kpl__pill ' + cls; pill.textContent = txt;
      Array.prototype.forEach.call(c.querySelectorAll('tr[data-day]'), function (tr) { tr.classList.toggle('is-today', +tr.getAttribute('data-day') === day); });
    });
  }

  function apply() {
    var raw = input.value, q = norm(raw), words = q ? q.split(' ') : [], shown = 0;
    cards.forEach(function (c) {
      var ok = (brand === 'all' || c.getAttribute('data-brand') === brand) && words.every(function (w) { return c._k.indexOf(w) > -1; });
      c.hidden = !ok; if (ok) shown++;
    });
    var ranked = cards.slice();
    if (mode === 'near' && here) {
      ranked.sort(function (a, b) { return a._d - b._d; });
      ranked.forEach(function (c, i) { c.style.order = i; });
      heads.forEach(function (h) { h.hidden = true; });
    } else {
      cards.forEach(function (c) { c.style.order = c._i; });
      heads.forEach(function (h) {
        h.style.order = h._i;
        var b = h.getAttribute('data-ghead');
        h.hidden = !cards.some(function (c) { return !c.hidden && c.getAttribute('data-brand') === b; });
      });
    }
    picks.forEach(function (p) { p.classList.toggle('is-on', q !== '' && norm(p.getAttribute('data-pick')) === q); });
    clear.hidden = !q;
    empty.hidden = shown > 0; term.textContent = raw.trim();
    count.textContent = shown === cards.length ? cards.length + ' stores' : shown + ' of ' + cards.length + ' stores';
    if (desk.matches && shown && (!selected || selected.hidden)) {
      var first = (mode === 'near' && here) ? ranked.filter(function (c) { return !c.hidden; })[0] : cards.filter(function (c) { return !c.hidden; })[0];
      if (first && mapBox.classList.contains('has-map')) select(first, false);
    }
  }

  function frame(c) {
    var f = document.createElement('iframe');
    f.src = 'https://maps.google.com/maps?q=' + encodeURIComponent(c.getAttribute('data-mapq')) + '&z=16&output=embed';
    f.title = 'Map of ' + c.getAttribute('data-name'); f.loading = 'lazy'; f.referrerPolicy = 'no-referrer-when-downgrade';
    return f;
  }
  function select(c, scroll) {
    if (selected) selected.classList.remove('is-selected');
    selected = c; c.classList.add('is-selected');
    if (desk.matches) {
      mapBox.innerHTML = ''; mapBox.appendChild(frame(c)); mapBox.classList.add('has-map');
      mapName.textContent = c.getAttribute('data-name');
      mapDir.href = c.getAttribute('data-dir'); mapDir.hidden = false;
    } else {
      var slot = c.querySelector('[data-mapslot]'), btn = c.querySelector('[data-show-map]');
      if (slot.firstChild) { slot.innerHTML = ''; btn.textContent = 'Show on map'; btn.setAttribute('aria-expanded', 'false'); }
      else { slot.appendChild(frame(c)); btn.textContent = 'Hide map'; btn.setAttribute('aria-expanded', 'true'); }
    }
    if (scroll) c.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function useLocation() {
    if (!navigator.geolocation) { msg.hidden = false; msg.textContent = 'Location is not available in this browser. Search your area instead.'; return; }
    locate.setAttribute('aria-busy', 'true'); msg.hidden = false; msg.textContent = 'Finding your location...';
    navigator.geolocation.getCurrentPosition(function (p) {
      here = [p.coords.latitude, p.coords.longitude];
      cards.forEach(function (c) {
        c._d = km(here[0], here[1], c._lat, c._lng);
        var el = c.querySelector('[data-dist]'); el.hidden = false;
        el.textContent = (c._d < 10 ? c._d.toFixed(1) : Math.round(c._d)) + ' km away';
      });
      locate.removeAttribute('aria-busy');
      setSort('near'); msg.textContent = 'Sorted by distance from you (straight-line).';
      var nearest = cards.slice().sort(function (a, b) { return a._d - b._d; })[0];
      if (desk.matches) select(nearest, false);
      $('.kpl__layout').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, function () {
      locate.removeAttribute('aria-busy');
      msg.hidden = false; msg.textContent = 'We could not get your location. Allow location access, or type your area above.';
      setSort('rec', true);
    }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 600000 });
  }
  function setSort(m, quiet) {
    mode = m;
    sorts.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-sort') === m ? 'true' : 'false'); });
    if (m === 'rec' && !quiet) msg.hidden = true;
    apply();
  }

  input.addEventListener('input', apply);
  clear.addEventListener('click', function () { input.value = ''; apply(); input.focus(); });
  picks.forEach(function (p) { p.addEventListener('click', function () { input.value = p.getAttribute('data-pick'); apply(); }); });
  chips.forEach(function (c) {
    c.addEventListener('click', function () {
      brand = c.getAttribute('data-brand-btn');
      chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
      apply();
    });
  });
  sorts.forEach(function (b) {
    b.addEventListener('click', function () {
      var m = b.getAttribute('data-sort');
      if (m === 'near' && !here) useLocation(); else setSort(m);
    });
  });
  locate.addEventListener('click', useLocation);
  $('[data-reset]').addEventListener('click', function () {
    input.value = ''; brand = 'all';
    chips.forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-brand-btn') === 'all' ? 'true' : 'false'); });
    apply(); input.focus();
  });
  cards.forEach(function (c) {
    c.querySelector('[data-show-map]').addEventListener('click', function () { select(c, false); });
    c.addEventListener('click', function (e) {
      if (!desk.matches || e.target.closest('a,button,summary,details')) return;
      select(c, false);
    });
  });

  try { var a = new URLSearchParams(location.search).get('area'); if (a) input.value = a; } catch (e) {}
  status(); setInterval(status, 60000);
  apply();
  var t = null; try { t = location.hash ? root.querySelector(location.hash) : null; } catch (e) {}
  if (t) { if (t && t.hasAttribute('data-store')) { setTimeout(function () { select(t, true); }, 300); } }
  /* load the map only after the page has loaded, so it never slows first paint */
  var go = function () { if (desk.matches && !selected) { var f = cards.filter(function (c) { return !c.hidden; })[0]; if (f) select(f, false); } };
  var idle = function () { if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 2500 }); else setTimeout(go, 1200); };
  if (document.readyState === 'complete') idle(); else window.addEventListener('load', idle);
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-kpl]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-kpl]')); });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kp-corporate-bulk-orders"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var trigger = event.target.closest('[data-kp-scroll]');
    if (!trigger) return;
    var selector = trigger.getAttribute('href');
    if (!selector || selector.charAt(0) !== '#') return;
    var target = document.querySelector(selector);
    if (!target) return;
    event.preventDefault();
    var scrollToTarget = function() {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    if (document.startViewTransition) {
      document.startViewTransition(scrollToTarget);
    } else {
      scrollToTarget();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-banner"] && !Shopify.designMode) return;
  try {
    
  class ParallaxImage extends HTMLElement {
    constructor() {
      super();
      
    }
  connectedCallback() {
    const sectionId = this.getAttribute('section-id');
    const image = this.querySelector('img');
    const aosAnimation = this.getAttribute('data-aos');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          window.addEventListener('scroll', this.parallaxEffect);
        } else {
          window.removeEventListener('scroll', this.parallaxEffect);
        }
      });
    });

    const section = document.getElementById(sectionId);
    observer.observe(section);

    const imageContainer = this;
    imageContainer.style.transform = 'translateY(0)';

    this.parallaxEffect = () => {
      const scrollPosition = window.pageYOffset;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      const parallaxValue = (scrollPosition / maxScroll) * 50;
      image.style.transform = `translateY(-${parallaxValue}%) scale(1.2)`;
    };

  }
}

customElements.define('parallax-image', ParallaxImage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"]) return;
  try {
    
  class productPairs extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url).
      then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error! Status: ".concat(response.status));
        }
        return response.text();
      }).
      then((response) => {
        var frag = document.createDocumentFragment(),
          fetchedContent = document.createElement('div');
        frag.appendChild(fetchedContent);
        fetchedContent.innerHTML = response;

        var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
        if (replacementContent) {
          this.innerHTML = replacementContent.innerHTML;
        }
      });
    }
  }

  customElements.define('product-pairs', productPairs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
 
class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
              const swiperContainer = this.querySelector('.swiper-container');
              const getID = swiperContainer.getAttribute("data-id");
              const swiperID = this.querySelector(`.swipercol-${getID}`);
              const spaceBetween = parseInt(swiperContainer.getAttribute('data-space-between'), 10);
              const perviewDesktop = swiperContainer.getAttribute('data-perview-desktop');
              if (swiperContainer) {
                new Swiper(swiperContainer, {
                  slidesPerView: "auto",
                  freeMode: false,
                  autoHeight: true,
                  calculateHeight:true,
                  freeModeSticky: true,
                  centeredSlides: false,
                  grabCursor: true,
                  watchSlidesVisibility: true,
                  watchSlidesProgress: true,
                  preloadImages: true,
                  updateOnImagesReady: true,
                  spaceBetween: spaceBetween,
                  observer: true,
                  observeParents: true,
                  parallax:true,
                  a11y: true,
                  loop: true,
                  keyboard: {
                    enabled: true,
                  },
                  breakpoints: {
                    320: {
                      slidesPerView: 2,
                      spaceBetween: 20
                    },
                    576: {
                      slidesPerView: 2,
                    },
                    768: {
                      slidesPerView: 3,
                    },
                    992: {
                      slidesPerView: perviewDesktop,
                    }
                  },
                  scrollbar: {
                    el: this.querySelector(".swiper-scrollbar"),
                  },
                  navigation: {
                    nextEl: this.querySelector(".swiper-button-next"),
                    prevEl: this.querySelector(".swiper-button-prev"),
                  },
                });
              } else {
                console.error('No element with class "swiper-container" found.');
              }
            }
            if(typeof jdgm !== 'undefined'){
              jdgm.customizeBadges();
            }
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    
  class productPairsRight extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url)
        .then((response) => {
          if (!response.ok) {
            throw new Error('HTTP error! Status: '.concat(response.status));
          }
          return response.text();
        })
        .then((response) => {
          var frag = document.createDocumentFragment(),
            fetchedContent = document.createElement('div');
          frag.appendChild(fetchedContent);
          fetchedContent.innerHTML = response;

          var replacementContent = fetchedContent.querySelector('[data-id="'.concat(CSS.escape(this.dataset.id), '"]'));
          if (replacementContent) {
            this.innerHTML = replacementContent.innerHTML;
          }
        });
    }
  }

  customElements.define('product-pairsright', productPairsRight);

  class BuyNow extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.handleClick.bind(this));
    }

    connectedCallback() {
      this.checkAgreement();
    }

    handleClick(event) {
      const agreeCheckbox = this.querySelector('.checkbox__input');
      const checkoutButton = this.querySelector('.product-form__buynow');

      if (event.target === agreeCheckbox || event.target === this.querySelector('.checkbox__label')) {
        if (agreeCheckbox.checked) {
          checkoutButton.classList.remove('disabled');
        } else {
          checkoutButton.classList.add('disabled');
        }
      }
    }
    checkAgreement() {
      const agreeCheckbox = this.querySelector('.checkbox__input');
      return agreeCheckbox.checked;
    }
  }

  customElements.define('buy-now', BuyNow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  !function(){function e(e){this.element=e,this.blocks=this.element.getElementsByClassName("js-cd-block"),this.images=this.element.getElementsByClassName("js-cd-img"),this.contents=this.element.getElementsByClassName("js-cd-content"),this.offset=.8,this.hideBlocks()}e.prototype.hideBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.blocks[e].getBoundingClientRect().top>window.innerHeight*t.offset&&(t.images[e].classList.add("cd-is-hidden"),t.contents[e].classList.add("cd-is-hidden"))},e.prototype.showBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.contents[e].classList.contains("cd-is-hidden")&&t.blocks[e].getBoundingClientRect().top<=window.innerHeight*t.offset&&(t.images[e].classList.add("or-timeline__img--bounce-in"),t.contents[e].classList.add("or-timeline__content--bounce-in"),t.images[e].classList.remove("cd-is-hidden"),t.contents[e].classList.remove("cd-is-hidden"))};var t,s=document.getElementsByClassName("js-or-timeline"),n=[],i=!1;if(s.length>0){for(var o=0;o<s.length;o++)t=o,n.push(new e(s[t]));window.addEventListener("scroll",function(e){i||(i=!0,window.requestAnimationFrame?window.requestAnimationFrame(c):setTimeout(c,250))})}function c(){n.forEach(function(e){e.showBlocks()}),i=!1}}();

  } catch(e) { console.error(e); }
})();
})();
